<template >
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <div class="d-flex justify-content-between align-items-center">
          <p style="font-size: 2vw"> ماتریس ارتباطات درونی</p>
          <button style="transform: translateX(3vw)" class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>


        </div>
        <hr>
        <br>
        <div class="d-flex flex-nowrap ">
          <div class="card p-4 w-50">
            <center>
              <p style="font-weight: bold; font-size: 1.3vw;">ارتباط فرآیندها در سطح طبقه</p>

              <br>
              <router-link class="btn btn-submit-1 btn-info w-50" to="/Matrix_Connections/include/by/1">تکمیل اطلاعات / بروزرسانی</router-link>
            </center>
          </div>
          <div class="card p-4 w-50 mx-2">
            <center>
              <p style="font-weight: bold; font-size: 1.3vw;">ارتباط فرآیندها در سطح گروه</p>
              <br>
              <router-link class="btn btn-submit-1 btn-info w-50" to="/Matrix_Connections/include/by/2">تکمیل اطلاعات / بروزرسانی</router-link>
            </center>
          </div>
        </div>
        <br>
        <div class="d-flex flex-nowrap ">
          <div class="card p-4 w-50">
            <center>
              <p style="font-weight: bold; font-size: 1.3vw;">ارتباط فرآیندها در سطح فرآیند</p>
              <br>
              <router-link class="btn btn-submit-1 btn-info w-50" to="/Matrix_Connections/include/by/3">تکمیل اطلاعات / بروزرسانی</router-link>
            </center>
          </div>
          <div class="card p-4 w-50 mx-2">
            <center>
              <p style="font-weight: bold; font-size: 1.3vw;">ارتباط فرآیندها در سطح  زیر فرآیند</p>
              <br>
              <router-link class="btn btn-submit-1 btn-info w-50" to="/Matrix_Connections/include/by/4">تکمیل اطلاعات / بروزرسانی</router-link>
            </center>
          </div>
        </div>
        <br>
        <div class="d-flex flex-nowrap ">
          <div class="card p-4 w-50">
            <center>
              <p style="font-weight: bold; font-size: 1.3vw;"> ارتباط فرآیند  - پست سازمانی</p>
              <br>
              <router-link class="btn btn-submit-1 btn-info w-50" to="/Matrix_Connections/include/by/5">تکمیل اطلاعات / بروزرسانی</router-link>
            </center>
          </div>


        </div>



      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";

export default {
  name: 'HomeView',
  components: {
    Sidebar,
    splash
  },
  methods:{
    checkIsMother(){
      if (this.is_mother){
        router.push('/mother_items')
        return
      }

    }
  },
  mounted() {
    this.checkIsMother()
  }
}
</script>
